import React from 'react';

const ErrorCookiesSettings = ({ errorText }) => <p>{errorText}</p>;

export default ErrorCookiesSettings;
